import { Popup } from "./Popup";
export class TextPopup extends Popup {
    display() {
        super.display();
        this.container.style.paddingTop = "170px";
    }
}
